export class ReferralProgramWidgetSettings {
  public referralUrl: string;
}
